import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';

export const viewerSteps = [
  {
    element: '[data-onboarding="viewer-toolbar"]',
    popover: {
      title: 'Search & Sort',
      description:
        'Use the search bar to find customers, sites, or devices by name. Sort your list by name, sites, or devices count, and toggle ascending/descending order.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="viewer-hierarchy"]',
    popover: {
      title: 'Customer Hierarchy',
      description:
        'Browse through your customers, sites, and devices in a tree view. Click to expand and select items. Right-click for quick actions.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="viewer-detail"]',
    popover: {
      title: 'Detail Panel',
      description:
        'View and edit details for the selected customer, site, or device here. The panel updates based on your selection in the hierarchy.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
];

export const viewerRoutes: RouteConfig[] = [
  {
    id: 'viewer',
    processName: ONBOARDING_KEYS.viewer,
    match: (path: string) => path === '/viewer',
    steps: viewerSteps,
  },
];

